export { BeerCard } from "./beer-card";
export { BeerCardInteractive } from "./beer-card-interactive";
export type { BeerCardProps } from "./beer-card.interface";
